import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import SecuredMetaSites from '@piwikpro/meta-sites-crate/components/SecuredMetaSites';
import MetaSiteDetails from '../../../administration/src/components/MetaSites/MetaSiteDetails';

const SecuredMetaSiteDetails = () => (
  <SecuredMetaSites component={MetaSiteDetails} />
);

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId')({
  component: SecuredMetaSiteDetails,
});
